import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import APIURL from "../../common/Config";
import "../call-chat/Call.css";
import defaultProfileImage from "../../assets/profilechat.webp";
import chatImage from "../../assets/profilechat.webp";
import Header from "../header/header";
import Footer from "../footer/footer";
import { useDispatch } from "react-redux";
import { openAuthModal } from "../../redux/authSlice";

// ─── Helper ──────────────────────────────────────────────────────────────────
const getCustomerId = () => localStorage.getItem("customerId");

const Toast = ({ message, onHide }) => {
  useEffect(() => {
    const t = setTimeout(onHide, 3000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={{
      position: "fixed",
      bottom: "30px",
      left: "50%",
      transform: "translateX(-50%)",
      background: "#333",
      color: "#fff",
      padding: "12px 24px",
      borderRadius: "8px",
      fontSize: "14px",
      fontWeight: "600",
      zIndex: 9999999,
      boxShadow: "0 4px 16px rgba(0,0,0,0.3)",
      whiteSpace: "nowrap",
    }}>
      {message}
    </div>
  );
};

// ─── Active Call Screen ───────────────────────────────────────────────────────
const ActiveCallScreen = ({ astrologerData, onClose, onEndCall, ending }) => {
  const [seconds, setSeconds] = useState(0);
  const [connected, setConnected] = useState(false);
  const autoCloseTimerRef = useRef(null);
  const durationTimerRef = useRef(null);

  useEffect(() => {
    // 15s auto-close — same as app's UserCallScreen
    autoCloseTimerRef.current = setTimeout(() => {
      onClose();
    }, 15000);

    return () => {
      clearTimeout(autoCloseTimerRef.current);
      clearInterval(durationTimerRef.current);
    };
  }, []);

  useEffect(() => {
    if (!connected) return;
    clearTimeout(autoCloseTimerRef.current);
    durationTimerRef.current = setInterval(() => setSeconds((s) => s + 1), 1000);
    return () => clearInterval(durationTimerRef.current);
  }, [connected]);

  const fmt = (s) => {
    const m = String(Math.floor(s / 60)).padStart(2, "0");
    const sec = String(s % 60).padStart(2, "0");
    return `${m}:${sec}`;
  };

  const handleCancel = () => {
    clearTimeout(autoCloseTimerRef.current);
    clearInterval(durationTimerRef.current);
    onClose();
  };

  return (
    <div className="ac-overlay">
      <div className="ac-bg-glow" />
      <div className="ac-card">

        <div className="ac-avatar-wrap">
          <img
            src={astrologerData?.photoUrlPath || defaultProfileImage}
            className="ac-avatar"
            alt="Astrologer"
            onError={(e) => { e.target.src = defaultProfileImage; }}
          />
          <div className={`ac-pulse-ring ${connected ? "ac-pulse-active" : ""}`} />
          {connected && <span className="ac-live-badge">LIVE</span>}
        </div>

        <p className="ac-name">{astrologerData?.name || "Astrologer"}</p>
        <p className="ac-status-text">
          {connected ? "Call Connected" : "Connecting..."}
        </p>

        {connected ? (
          <>
            <div className="ac-timer">{fmt(seconds)}</div>
            <button className="ac-cut-btn" onClick={onEndCall} disabled={ending}>
              {ending ? "Ending…" : "End Call"}
            </button>
          </>
        ) : (
          <>
            <div className="ac-connecting">
              <div className="ac-dots-row">
                {[0, 1, 2].map((i) => (
                  <span
                    key={i}
                    className="ac-dot-anim"
                    style={{ animationDelay: `${i * 0.2}s` }}
                  />
                ))}
              </div>
            </div>
            <button className="ac-cut-btn" onClick={handleCancel}>
              Cancel
            </button>
          </>
        )}

      </div>
    </div>
  );
};

// ─── Payment Modal ────────────────────────────────────────────────────────────
const AMOUNTS = [10, 100, 200, 500, 1000, 1500, 2000, 2500, 3000];

const PaymentModal = ({ msg, onClose, onPay }) => {
  const [selected, setSelected] = useState(null);

  return (
    <div className="cmod-overlay" onClick={onClose}>
      <div className="cmod-box cmod-box-payment" onClick={(e) => e.stopPropagation()}>
        <button className="cmod-close-x" onClick={onClose}>✕</button>
        <div className="cmod-emoji">💰</div>
        <h3>Insufficient Balance</h3>
        {msg && <div className="cmod-payment-msg">{msg}</div>}
        <p className="cmod-recharge-heading">Recharge Now</p>
        <div className="cmod-amounts-grid">
          {AMOUNTS.map((amt) => (
            <button
              key={amt}
              className={`cmod-amount-btn ${selected === amt ? "cmod-amount-selected" : ""}`}
              onClick={() => setSelected(amt)}
            >
              ₹ {amt}
            </button>
          ))}
        </div>
        <button
          className={`cmod-btn cmod-btn-primary ${!selected ? "cmod-btn-disabled" : ""}`}
          disabled={!selected}
          onClick={() => selected && onPay(selected)}
        >
          Proceed to Pay
        </button>
        <button className="cmod-btn cmod-btn-ghost" onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
};

// ─── Info Modal ───────────────────────────────────────────────────────────────
const InfoModal = ({ message, onClose }) => (
  <div className="cmod-overlay" onClick={onClose}>
    <div className="cmod-box" onClick={(e) => e.stopPropagation()}>
      <button className="cmod-close-x" onClick={onClose}>✕</button>
      <div className="cmod-emoji">ℹ️</div>
      <p>{message}</p>
      <button className="cmod-btn cmod-btn-primary" onClick={onClose}>OK</button>
    </div>
  </div>
);

// ─── Astrologer Card — UI SAME AS ORIGINAL ───────────────────────────────────
const AstrologerProfile = ({
  image, stars, orders, name, gender, details,
  experience, Age, rate, astrologerId, callStatus, status,
  onCallPress, loadingId,isFollowing, onFollowToggle,
}) => {
  const [profileImage, setProfileImage] = useState(image || defaultProfileImage);
  const isBusy = status === 5;
  const isLoading = loadingId === astrologerId;

  return (
    <div className="astrologer-chat">
      {/* <div className="profile">
        <img
          src={profileImage}
          alt={name}
          className="profile-image"
          onError={() => setProfileImage(defaultProfileImage)}
        />
        <p className="stars">{stars}</p>
        <p className="orders">{orders} orders</p>
      </div> */}
      <div className="profile">
        <img
          src={profileImage}
          alt={name}
          className="profile-image"
          onError={() => setProfileImage(defaultProfileImage)}
        />
        <button
          className={`follow-btn ${isFollowing ? "follow-btn-following" : "follow-btn-follow"}`}
          onClick={(e) => { e.stopPropagation(); onFollowToggle(astrologerId); }}
        >
          {isFollowing ? "Following" : "Follow"}
        </button>
        <p className="stars">{stars}</p>
        <p className="orders">{orders} orders</p>
      </div>

      <div className="content">
        <p className="name">{name}</p>
        <p className="details">{details}</p>
        <p className="genders">Gender: {gender}</p>
        <p className="Age">Age: {Age}</p>

        <div className="chatbutton">
          <p className="experience">Exp: {experience} Years</p>
          <button
            className={`call-button ${isBusy ? "call-button-busy" : ""}`}
            disabled={isBusy || isLoading}
            onClick={() => !isBusy && !isLoading && onCallPress(astrologerId, callStatus)}
          >
            {isLoading ? (
              <span className="call-btn-spinner-sm" />
            ) : isBusy ? (
              "Busy"
            ) : (
              "Call"
            )}
          </button>
        </div>

        <p className="rate">
          <span>₹ {rate}/min</span>
        </p>
      </div>

      <div className={`card-status ${callStatus === 2 ? "online" : "offline"}`}>
        <div className="status-dot" />
      </div>
    </div>
  );
};

// ─── Main Grid ────────────────────────────────────────────────────────────────
const AstrologerGrid = () => {
  const navigate = useNavigate();

  const [astrologers, setAstrologers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [activeFilter, setActiveFilter] = useState("all");

  const [paymentModal, setPaymentModal] = useState(null);
  const [infoModal, setInfoModal] = useState(null);
  const [loadingId, setLoadingId] = useState(null);
  const [toast, setToast] = useState(null); // toast message

  const [activeCall, setActiveCall] = useState(null);
  const [endingCall, setEndingCall] = useState(false);

  const [followStatus, setFollowStatus] = useState({});
  const dispatch = useDispatch();

  const handleFollowUnfollow = async (astrologerId) => {
    const isLoggedInRaw = localStorage.getItem("isLoggedIn");
    const customerId = localStorage.getItem("customerId");
    const isLoggedValid = (isLoggedInRaw === "true" || isLoggedInRaw === true);

    if (!isLoggedValid || !customerId) {
      setToast("Please login to continue.");
      dispatch(openAuthModal('login'));
      return;
    }

    const currentlyFollowing = followStatus[astrologerId] || false;
    const url = `${APIURL}/astro/followers/${currentlyFollowing ? 'unfollow' : 'follow'}?astrologerId=${astrologerId}&customerId=${customerId}`;
    const method = currentlyFollowing ? 'delete' : 'post';

    const astrologerName = astrologers.find(a => a.astrologerId === astrologerId)?.name || "Astrologer";

    try {
      await axios({ method, url, headers: { 'Accept': '*/*' } });
      setFollowStatus((prev) => ({ ...prev, [astrologerId]: !currentlyFollowing }));
      setToast(currentlyFollowing ? `Unfollowed ${astrologerName}` : `Following ${astrologerName}! `);
    } catch (error) {
      setToast("Follow/Unfollow failed. Try again.");
    }
  };
  // ── Fetch astrologers — original API ─────────────────────────────────────
  const fetchAstrologers = useCallback(async () => {
    setLoading(true);
    try {
      // const response = await axios.get(
      //   `${APIURL}/astroservice/list/astrologer/loggedin?customerId=0`
      // );
      // const rawData = response.data;
      // const active = rawData.filter((a) => a.status === 1);

      // const formatted = active.map((astrologer) => ({
      //   image: astrologer.photoUrlpath || chatImage,
      //   stars: "★★★★★",
      //   orders: astrologer.callCount || 0,
      //   name: astrologer.firstName,
      //   gender: astrologer.gender,
      //   details: `${astrologer.specialization} | ${astrologer.language}`,
      //   Age: `${astrologer.age} yr`,
      //   experience: astrologer.experience,
      //   rate: astrologer.callCharges,
      //   isWaiting: astrologer.callStatus === 2,
      //   astrologerId: astrologer.astrologerId,
      //   callStatus: astrologer.callStatus,
      //   status: astrologer.status,
      //   photoUrlPath: astrologer.photoUrlpath,
      //   firstName: astrologer.firstName,
      // }));

      // setAstrologers(formatted);
      // setError(null);
      const storedCustomerId = localStorage.getItem("customerId") || "0";
      const response = await axios.get(
        `${APIURL}/astroservice/list/astrologer/loggedin?customerId=${storedCustomerId}`
      );
      const rawData = response.data;
      const active = rawData.filter((a) => a.status === 1);

      const formatted = active.map((astrologer) => ({
        image: astrologer.photoUrlpath || chatImage,
        stars: "★★★★★",
        orders: astrologer.callCount || 0,
        name: astrologer.firstName,
        gender: astrologer.gender,
        details: `${astrologer.specialization} | ${astrologer.language}`,
        Age: `${astrologer.age} yr`,
        experience: astrologer.experience,
        rate: astrologer.callCharges,
        isWaiting: astrologer.callStatus === 2,
        astrologerId: astrologer.astrologerId,
        callStatus: astrologer.callStatus,
        status: astrologer.status,
        photoUrlPath: astrologer.photoUrlpath,
        firstName: astrologer.firstName,
        following: astrologer.following || false,
      }));

      setAstrologers(formatted);
      const initialFollow = {};
      formatted.forEach(a => {
        initialFollow[a.astrologerId] = a.following || false;
      });
      setFollowStatus(initialFollow);
      setError(null);
    } catch (err) {
      setError("Error fetching astrologers");
      console.error("Error fetching astrologers:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAstrologers();
  }, [fetchAstrologers]);

  // ── verifybalanceastrochat — offline check added ──────────────────────────
  const verifybalanceastrochat = async (astrologerIdParam, callStatus) => {
    // ── OFFLINE CHECK — call mat lagao, toast dikha do ────────────────────
    if (callStatus !== 2) {
      setToast("Astrologer is currently offline");
      return;
    }

    if (loadingId) return;
    setLoadingId(astrologerIdParam);

    try {
      const customerId = getCustomerId();
      if (!astrologerIdParam || !customerId) {
        setInfoModal("Invalid data. Please try again.");
        return;
      }

      const apiUrl = `${APIURL}/astrochat2026/verifybalance/CALL/${customerId}/${astrologerIdParam}`;
      const response = await axios.get(apiUrl);
      const data = response.data;

      localStorage.setItem("astroData", JSON.stringify({
        name: data.name,
        photoUrlPath: data.photoUrlPath,
      }));
      localStorage.setItem("selectedAstrologerId", JSON.stringify(astrologerIdParam));

      if (data.callAction === "CALL") {
        await callservicepostAPI(astrologerIdParam, {
          name: data.name,
          photoUrlPath: data.photoUrlPath,
        });
      } else if (data.callAction === "PAYMENT") {
        setPaymentModal({ msg: data.msg || "Insufficient balance. Please recharge." });
      } else {
        navigate("/inquiry-details", { state: { astrologerId: astrologerIdParam } });
      }
    } catch (err) {
      console.error("verifybalanceastrochat error:", err.message);
      setInfoModal("An error occurred. Please try again.");
    } finally {
      setLoadingId(null);
    }
  };

  // ── callservicepostAPI — same as app ──────────────────────────────────────
  const callservicepostAPI = async (astrologerIdParam, astrologerData) => {
    try {
      const customerId = getCustomerId();
      if (!astrologerIdParam || !customerId) return;

      const payload = { astrologerId: astrologerIdParam, customerId };
      const response = await axios.post(
        `${APIURL}/callservice/initiatecallrequest`,
        payload,
        { headers: { accept: "*/*", "Content-Type": "application/json" } }
      );

      console.log("initiatecallrequest API response:", response.data);
      console.log("callCdrId:", response.data.callCdrId);

      setActiveCall({
        callData: response.data,
        astrologerData: astrologerData || {},
      });
    } catch (err) {
      console.error("Error initiating call:", err?.response || err);
      setInfoModal("Failed to initiate call. Please try again.");
    }
  };

  // ── handleEndCall ─────────────────────────────────────────────────────────
  const handleEndCall = async () => {
    setEndingCall(true);
    try {
      const callCdrId = activeCall?.callData?.callCdrId;
      if (callCdrId) {
        await axios.post(`${APIURL}/callservice/cutcall/${callCdrId}`);
      }
    } catch (err) {
      console.error("End call error:", err);
    } finally {
      setEndingCall(false);
      setActiveCall(null);
      fetchAstrologers();
    }
  };

  // ── handleAutoClose — 15s timeout ya Cancel ───────────────────────────────
  const handleAutoClose = () => {
    setActiveCall(null);
    fetchAstrologers();
  };

  // ── Payment proceed ───────────────────────────────────────────────────────
  const handlePayment = (amount) => {
    setPaymentModal(null);
    navigate("/wallet", { state: { paramKey: amount } });
  };

  // ── Filter / Search ───────────────────────────────────────────────────────
  const filtered = astrologers
    .filter((a) => {
      if (activeFilter === "active") return a.callStatus === 2;
      if (activeFilter === "inactive") return a.callStatus !== 2;
      return true;
    })
    .filter((a) =>
      a.name?.toLowerCase().includes(searchQuery.toLowerCase())
    );

  if (loading) return <div className="loading-container"><p>Loading Astrologers...</p></div>;
  if (error) return <div className="error-container"><p>{error}</p></div>;

  return (
    <>
      {/* Toast — offline message */}
      {toast && (
        <Toast message={toast} onHide={() => setToast(null)} />
      )}

      {/* Active call overlay */}
      {activeCall && (
        <ActiveCallScreen
          astrologerData={activeCall.astrologerData}
          callData={activeCall.callData}
          onClose={handleAutoClose}
          onEndCall={handleEndCall}
          ending={endingCall}
        />
      )}

      {/* Payment modal */}
      {paymentModal && (
        <PaymentModal
          msg={paymentModal.msg}
          onClose={() => setPaymentModal(null)}
          onPay={handlePayment}
        />
      )}

      {/* Info modal */}
      {infoModal && (
        <InfoModal
          message={infoModal}
          onClose={() => setInfoModal(null)}
        />
      )}

      {/* Controls — 100% same as original */}
      <div className="ag-controls">
        <div className="ag-header-row">
          <div className="ag-title-block">
            <div>
            {/* <h2 className="ag-title">Call with our Expert
              <br /> Astrologers</h2> */}
               <h2 className="ag-title">
  Call with our{" "}
  <span style={{ color: "#89184a" }}>Expert</span>
  <br />Astrologers
</h2>
              <p className="ag-subtitle">
      Connect with India's most trusted spiritual guides for deep insights into your birth chart, career, and love life.
    </p>
              </div>
            <span className="ag-count">{filtered.length} Available</span>
          </div>

          <div className="ag-search-wrap">
            <svg className="ag-search-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
            </svg>
            <input
              className="ag-search-input"
              type="text"
              placeholder="Search by name..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              autoComplete="off"
            />
            {searchQuery && (
              <button className="ag-search-clear" onClick={() => setSearchQuery("")}>✕</button>
            )}
          </div>

          <div className="ag-toggle-wrap">
            {[
              { key: "all", label: "All" },
              { key: "active", label: "Online" },
              { key: "inactive", label: "Offline" },
            ].map((f) => (
              <button
                key={f.key}
                className={`ag-toggle-btn ${activeFilter === f.key ? "ag-toggle-active" : ""}`}
                onClick={() => setActiveFilter(f.key)}
              >
                <span className={`ag-dot ${f.key === "active" ? "ag-dot-green" : f.key === "inactive" ? "ag-dot-red" : "ag-dot-grey"}`} />
                {f.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="ag-empty"><p>No astrologers found</p></div>
      ) : null}

      {/* Cards — same UI as original */}
      <div className="container-main">
        {filtered.map((astrologer, index) => (
          // <AstrologerProfile
          //   key={astrologer.astrologerId || index}
          //   {...astrologer}
          //   onCallPress={verifybalanceastrochat}
          //   loadingId={loadingId}
          // />
           <AstrologerProfile
            key={astrologer.astrologerId || index}
            {...astrologer}
            onCallPress={verifybalanceastrochat}
            loadingId={loadingId}
            isFollowing={followStatus[astrologer.astrologerId] || false}
            onFollowToggle={handleFollowUnfollow}
          />
        ))}
      </div>
    </>
  );
};

// ─── App Page ─────────────────────────────────────────────────────────────────
function App() {
  const staticMeta = {
    title: "AstroBhagya – Call with Astrologer Online - Talk to Astrologer Free",
    description: "Call with astrologer online anytime! Get expert astrology guidance, live astrology call service, and personalized astrologer consultation 24x7.",
    keywords: "Call with Astrologer Online, Online astrologer consultation, Talk to astrologer on call, Astrology call service, Astrology guidance, Call astrologer now",
    author: "Heavenly Expectation Private Limited",
    revisitAfter: "7 days",
    distribution: "global",
    rating: "general",
  };

  useEffect(() => {
    document.title = staticMeta.title;
    const setOrCreateMetaTag = (name, content) => {
      let metaTag = document.querySelector(`meta[name="${name}"]`);
      if (metaTag) {
        metaTag.setAttribute("content", content);
      } else {
        metaTag = document.createElement("meta");
        metaTag.setAttribute("name", name);
        metaTag.setAttribute("content", content);
        document.head.appendChild(metaTag);
      }
    };
    setOrCreateMetaTag("description", staticMeta.description);
    setOrCreateMetaTag("keywords", staticMeta.keywords);
    setOrCreateMetaTag("author", staticMeta.author);
    setOrCreateMetaTag("revisit-after", staticMeta.revisitAfter);
    setOrCreateMetaTag("distribution", staticMeta.distribution);
    setOrCreateMetaTag("rating", staticMeta.rating);

    let charsetMeta = document.querySelector("meta[charset]");
    if (!charsetMeta) {
      charsetMeta = document.createElement("meta");
      charsetMeta.setAttribute("charset", "UTF-8");
      document.head.prepend(charsetMeta);
    }
  }, []);

  return (
    <div className="App">
      <Header />
      <AstrologerGrid />
      <br />
      <Footer />
    </div>
  );
}

export default App;
